<!-- Footer Start -->
<footer
  class="footer mt-auto xl:ps-[15rem] font-normal font-inter bg-white text-defaultsize leading-normal text-[0.813] shadow-[0_0_0.4rem_rgba(0,0,0,0.1)] dark:bg-bodybg py-4 text-center"
>
  <div class="container">
    <span class="text-gray dark:text-defaulttextcolor/50">
      Copyright © <span id="year">{{ currentYear }}</span>
      <a
        href="javascript:void(0);"
        class="text-defaulttextcolor font-semibold dark:text-defaulttextcolor"
      >
      Soar Global Institute</a>.
      {{ "allRightsReserved" | translate | capitalize }}.
    </span>
  </div>
</footer>
<!-- Footer End -->
